import { useState, useEffect, useRef } from "react";
import { Button } from "@mui/material";
import { MdAdd, MdDownload } from "react-icons/md";
import Swal from "sweetalert2";

// Import components
import SummaryModal from "./components/SummaryModal";
import SelectionTable from "./components/SelectionTable";
import AddSelectionModal from "./components/AddSelectionModal";
import PreviewTable from "./components/PreviewTable";
import { getSelectionViewSummary, generateNONGHYUPfile } from "../../Api";

const DataSelection = () => {
  // State variables
  // const [localStorageIsFlag, setLocalStorageIsFlag] = useState(false);

  const [summaryModal, setSummaryModal] = useState(false);
  const [rows, setRows] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalScenario, setModalScenario] = useState("");
  const [modalStartRange, setModalStartRange] = useState("");
  const [modalFileType, setModalFileType] = useState("");
  const [scenarios, setScenarios] = useState(null);
  const [combinationId, setCombinationId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [previewTableData, setPreviewTableData] = useState([]);
  const [previewTablePage, setPreviewTablePage] = useState(1);
  const [bankFileResponse, setBankFileResponse] = useState(null);
  const itemsPerPage = 5;
  const previewTableItemsPerPage = 5;
  // Ref to prevent double submission
  const saveLockRef = useRef(false);

  // Summary modal state
  const [modalCurrentPage, setModalCurrentPage] = useState(1);
  const [summaryData, setSummaryData] = useState([]);
  const [summaryTotalCount, setSummaryTotalCount] = useState(0);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [showPreviewTable, setShowPreviewTable] = useState(true);

  // Fetch summary data only when needed
  const fetchSummaryData = async (page = 1) => {
    setSummaryLoading(true);
    try {
      // Show SweetAlert2 loader
      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });

      const bank_code = localStorage.getItem("bank_code");
      const correl_id = localStorage.getItem("correl_id");
      const response = await getSelectionViewSummary({
        bank_code,
        correl_id,
        page: page,
        pageSize: itemsPerPage,
      });

      Swal.close();

      if (response && response.status === "S") {
        setSummaryData(response.result_info || []);
        setScenarios(response.scenariosApplied || []);
        setSummaryTotalCount(response.pagination?.totalCount || 0);

        // Debug: Log scenarios data structure
        console.log("Scenarios data:", response.scenariosApplied);
        if (response.scenariosApplied && response.scenariosApplied.length > 0) {
          console.log("First scenario object:", response.scenariosApplied[0]);
        }
      } else {
        setSummaryData([]);
        setSummaryTotalCount(0);
      }
    } catch (error) {
      Swal.close();
      setSummaryData([]);
      setSummaryTotalCount(0);
      showNotification("Error fetching summary data", "error");
    } finally {
      setSummaryLoading(false);
    }
  };

  // Fetch summary data when summary modal is opened (only once)
  useEffect(() => {
    if (summaryModal && summaryData.length === 0) {
      fetchSummaryData(modalCurrentPage);
    }
  }, [summaryModal]);

  // Fetch summary data when page changes in modal
  useEffect(() => {
    if (summaryModal && modalCurrentPage > 1) {
      fetchSummaryData(modalCurrentPage);
    }
  }, [modalCurrentPage]);

  // Fetch summary data when Add Selection Modal is opened
  useEffect(() => {
    if (modalOpen) {
      fetchSummaryData(1);
    }
  }, [modalOpen]);

  // Show loader when Add Selection Modal is opened and filename is loading
  useEffect(() => {
    if (modalOpen && (!summaryData || summaryData.length === 0)) {
      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });
    } else if (modalOpen && summaryData && summaryData.length > 0) {
      Swal.close();
    }
  }, [modalOpen, summaryData]);

  // useEffect(() => {
  //   const storedRows = localStorage.getItem("dataSelection_rows");

  //   if (storedRows) {
  //     try {
  //       const parsedRows = JSON.parse(storedRows);
  //       setRows(parsedRows);
  //     } catch (err) {
  //       console.error("Failed to parse stored rows", err);
  //       // localStorage.removeItem("dataSelection_rows");
  //     }
  //   }
  //   // ✅ mark hydration complete
  //   setLocalStorageIsFlag(true);
  // }, []);

  // useEffect(() => {
  //   if (!localStorageIsFlag) return; // 🛑 prevent overwrite

  //   localStorage.setItem("dataSelection_rows", JSON.stringify(rows));
  // }, [rows]);

  // Event handlers
  // const handleDeleteRow = async (id) => {
  //   // Find the row to be deleted to get its data
  //   const rowToDelete = rows.find(row => row.id === id);
  //   if (!rowToDelete) {
  //     showNotification('Row not found', 'error');
  //     return;
  //   }
  //   try {
  //     // Show confirmation dialog
  //     const result = await Swal.fire({
  //       title: 'Are you sure?',
  //       text: "You won't be able to revert this!",
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#d33',
  //       confirmButtonText: 'Yes, delete it!'
  //     });

  //     if (result.isConfirmed) {
  //       // Show loading
  //       Swal.fire({
  //         html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
  //         showConfirmButton: false,
  //         heightAuto: false,
  //         customClass: { popup: "loader-swal" },
  //         allowOutsideClick: false,
  //       });
  //       // Call the delete API using combination_id for single file deletion
  //       // const response = await deleteSelectedScenarioData({
  //       //   output_filename: rowToDelete.fileName,
  //       //   bank_code: localStorage.getItem("bank_code"),
  //       //   correl_id: localStorage.getItem("correl_id"),
  //       //   scenario: rowToDelete.scenario ? [rowToDelete.scenario] : [""],
  //       //   combination_id: rowToDelete.combination_id
  //       // });

  //       Swal.close();

  //       if (response && response.status === 'S') {
  //         Swal.fire({
  //           icon: "success",
  //           title: "Deleted!",
  //           text: "Selection has been deleted.",
  //           showConfirmButton: false,
  //           timer: 1500,
  //         });
  //         // Remove the row from local state
  //         setRows(prev => {
  //           const filtered = prev.filter(row => row.id !== id);
  //           return filtered;
  //         });
  //         // Clear preview table when a row is deleted
  //         setPreviewTableData([]);
  //         setPreviewTablePage(1);
  //         setBankFileResponse(null);
  //         showNotification('Selection deleted successfully!', 'success');
  //       } else {
  //         showNotification(response?.message || 'Failed to delete selection', 'error');
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Error deleting row:', error);
  //     showNotification('Error deleting selection. Please try again.', 'error');
  //   }
  // };

  const handleDeleteRow = async (id) => {
    // Locate the row (optional: log / use for messaging)
    const rowToDelete = rows.find((row) => row.id === id);
    if (!rowToDelete) {
      showNotification("Row not found", "error");
      return;
    }

    // Confirm delete
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will remove the selected row from the list.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    // Perform local deletion
    setRows((prev) => {
      const filtered = prev.filter((row) => row.id !== id);
      console.log("Rows after deletion:", filtered);
      return filtered;
    });

    // Clear related UI state
    setPreviewTableData([]);
    setPreviewTablePage(1);
    setBankFileResponse(null);

    // Notify user
    Swal.fire({
      icon: "success",
      title: "Deleted!",
      text: "The row has been removed.",
      showConfirmButton: false,
      timer: 1500,
    });

    showNotification("Selection deleted successfully!", "success");
  };

  const handleSummaryModal = () => {
    if (summaryModal) {
      // Closing the modal - clear data for fresh fetch next time
      setSummaryData([]);
      setSummaryTotalCount(0);
      setModalCurrentPage(1);
    }
    setSummaryModal(!summaryModal);
  };

  const handleOpenModal = () => {
    setModalScenario("");
    setModalStartRange("");
    setModalFileType("");
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    saveLockRef.current = false; // Reset lock when modal closes
  };

  const showNotification = (message, severity = "success") => {
    setNotification({ open: true, message, severity });
  };

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  // Handle bank file download
  const handleDownloadBankFile = async (bankFileData) => {
    if (!bankFileData || !bankFileData.fileName) {
      showNotification("No file available for download", "error");
      return;
    }

    try {
      // Create a direct download link for the bank file
      const downloadUrl = `https://upwardiqprism.com/api/files/bankfiles/${bankFileData.fileName}`;
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = bankFileData.fileName;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      showNotification("Bank file download started!", "success");
    } catch (error) {
      console.error("Error downloading bank file:", error);
      showNotification("Error downloading bank file", "error");
    }
  };

  //download single file
  const downloadSingleFile = async (fileName) => {
    if (!fileName) {
      showNotification("No file name provided", "error");
      return;
    }

    try {
      const downloadUrl = `https://upwardiqprism.com/api/files/bankfiles/${fileName}`;
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = fileName;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      showNotification(`Downloading ${fileName}...`, "success");
    } catch (error) {
      console.error("Error downloading file:", error);
      showNotification(`Error downloading ${fileName}`, "error");
    }
  };

  // Generate bank file functionality
  const handleGenerateFile = async (combinaton_id) => {
    if (!combinaton_id) {
      showNotification(
        "Please apply selection first to get combination ID",
        "warning"
      );
      return;
    }

    setIsLoading(true);
    try {
      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });
      const response = await generateNONGHYUPfile(combinaton_id);
      Swal.close();
      if (response && response.status === "S") {
        showNotification("Bank file generated successfully!", "success");
        setBankFileResponse(response);
        console.log("response", response.fileNames);
        const transformedData = response.result_info.map((row, index) => ({
          id: index + 1,
          col1: row.col1 || "",
          col2: row.TESTCASEID || "",
          col3: row.col3 || "",
          col4: row.col4 || "",
          col20: row.col5 || "",
          col23B: row.col6 || "",
          col32A: row.col7 || "",
          col50A: row.name || "",
          col57A: row.col8 || "",
          col59: row.col9 || "",
          col70: row.col10 || "",
          col71A: "",
          col72: "",
        }));
        setPreviewTableData(transformedData);
        setPreviewTablePage(1);
        setShowPreviewTable(true); // Show preview table when new data is set
      } else {
        showNotification(
          response?.message || "Failed to generate bank file",
          "error"
        );
      }
    } catch (error) {
      console.error("Error generating file:", error);
      showNotification(
        "Error generating bank file. Please try again.",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Modal pagination handlers
  const handleModalFirstPage = () => {
    if (summaryTotalCount > 0) {
      setModalCurrentPage(1);
      fetchSummaryData(1);
    }
  };
  const handleModalLastPage = () => {
    if (summaryTotalCount > 0) {
      const lastPage = Math.ceil(summaryTotalCount / itemsPerPage);
      setModalCurrentPage(lastPage);
      fetchSummaryData(lastPage);
    }
  };
  const handleModalPrevPage = () => {
    if (summaryTotalCount > 0 && modalCurrentPage > 1) {
      const prevPage = Math.max(modalCurrentPage - 1, 1);
      setModalCurrentPage(prevPage);
      fetchSummaryData(prevPage);
    }
  };
  const handleModalNextPage = () => {
    if (summaryTotalCount > 0) {
      const nextPage = Math.min(
        modalCurrentPage + 1,
        Math.ceil(summaryTotalCount / itemsPerPage)
      );
      if (nextPage > modalCurrentPage) {
        setModalCurrentPage(nextPage);
        fetchSummaryData(nextPage);
      }
    }
  };

  const handleHidePreviewTable = () => {
    setShowPreviewTable(false);
    setPreviewTableData([]);
    setPreviewTablePage(1);
    setBankFileResponse(null);
  };

  return (
    <div className="efficiency-page">
      <div className="page-container">
        <div className="row justify-content-between">
          <div className="col-12 col-md-4">
            <h5 className="mb-4">Data Selection</h5>
          </div>
          <div className="col-12 col-md-4 text-end">
            <button className="anchor-button" onClick={handleSummaryModal}>
              View Summary
            </button>
          </div>
        </div>

        {/* Summary Modal */}
        <SummaryModal
          isOpen={summaryModal}
          onClose={handleSummaryModal}
          summaryData={summaryData}
          currentPage={modalCurrentPage}
          itemsPerPage={itemsPerPage}
          totalCount={summaryTotalCount}
          onFirstPage={handleModalFirstPage}
          onLastPage={handleModalLastPage}
          onPrevPage={handleModalPrevPage}
          onNextPage={handleModalNextPage}
          loading={summaryLoading}
        />

        <div className="d-flex justify-content-end mb-3 gap-2">
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenModal}
            startIcon={<MdAdd />}
            sx={{
              backgroundColor: "var(--theme-color)",
              color: "#fff",
              "&:hover": {
                backgroundColor: "var(--theme-color)",
                opacity: 0.9,
              },
            }}
          >
            Add New Selection
          </Button>
          {/* {combinationId && previewTableData.length <= 0 && (
            <Button
              variant="contained"
              color="success"
              onClick={handleGenerateFile}
              disabled={isLoading}
              startIcon={<MdDownload />}
              sx={{
                backgroundColor: '#17a2b8',
                color: '#fff',
                '&:hover': {
                  backgroundColor: '#138496',
                },
                '&:disabled': {
                  backgroundColor: '#6c757d',
                },
              }}
            >
              {isLoading ? 'Generating...' : 'Generate Bank File'}
            </Button>
          )} */}
        </div>

        {/* Selection Table */}
        <SelectionTable
          rows={rows}
          combinationId={combinationId}
          onDeleteRow={handleDeleteRow}
          onPreviewClick={(val) => {
            handleGenerateFile(val);
          }}
          isLoading={isLoading}
        />

        {/* Preview Table for Bank File */}
        {showPreviewTable && previewTableData.length > 0 && (
          <PreviewTable
            tableFileType={"NonGhyup"}
            fileTypes={["NonGhyup"]}
            onFileTypeChange={() => {}}
            previewTableData={previewTableData}
            indexOfFirstItem={(previewTablePage - 1) * previewTableItemsPerPage}
            currentPage={previewTablePage}
            itemsPerPage={previewTableItemsPerPage}
            onFirstPage={() => setPreviewTablePage(1)}
            onLastPage={() =>
              setPreviewTablePage(
                Math.ceil(previewTableData.length / previewTableItemsPerPage)
              )
            }
            onPrevPage={() =>
              setPreviewTablePage((prev) => Math.max(prev - 1, 1))
            }
            onNextPage={() =>
              setPreviewTablePage((prev) =>
                Math.min(
                  prev + 1,
                  Math.ceil(previewTableData.length / previewTableItemsPerPage)
                )
              )
            }
            bankFileResponse={bankFileResponse}
            onDownloadBankFile={handleDownloadBankFile}
            onHidePreview={handleHidePreviewTable}
            fileNames={bankFileResponse?.fileNames || []} // Pass fileNames array
            onDownloadSingleFile={downloadSingleFile} // Pass download function
          />
        )}
      </div>

      {/* Add Selection Modal */}
      <AddSelectionModal
        open={modalOpen}
        onClose={handleCloseModal}
        summaryData={summaryData}
        scenario={modalScenario}
        onScenarioChange={(e) => {
          setModalScenario(e.target.value);
        }}
        startRange={modalStartRange}
        onStartRangeChange={(e) => setModalStartRange(e.target.value)}
        scenarios={scenarios || []}
        selectedFileType={modalFileType}
        onFileTypeChange={(e) => setModalFileType(e.target.value)}
        onGenerateSuccess={(combinationId, rowData) => {
          console.log(rowData);
          // Ensure unique id for each row
          setRows((prev) => {
            const newId =
              prev.length > 0 ? Math.max(...prev.map((r) => r.id)) + 1 : 1;
            return [...prev, { ...rowData, id: newId }];
          });
          setCombinationId(combinationId);
          // Clear preview table and bank file response when a new selection is added
          setPreviewTableData([]);
          setPreviewTablePage(1);
          setBankFileResponse(null);
          setShowPreviewTable(true); // Show preview table when new selection is added
          showNotification(
            `Selection generated successfully! Combination ID: ${combinationId}`,
            "success"
          );
        }}
      />
    </div>
  );
};

export default DataSelection;
